import { render, staticRenderFns } from "./welcome_siga.vue?vue&type=template&id=87bca3ba"
import script from "./welcome_siga.vue?vue&type=script&lang=js"
export * from "./welcome_siga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports